<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminForm from '@/components/admin/AdminForm.vue'
import AdminAdminMissionForm from '@/components/admin/adminMission/AdminAdminMissionForm.vue'
import { AloDbMission } from '@/models/alodb/AloDbMission'
import { SecurityItemsKeys } from '@/enum/SecurityItems'

@Component({
  name: 'AdminAdminMission', 
  components: {AdminAdminMissionForm},
  props:{
    itemid:{
      type:Number
    }
  }
})
export default class AdminAdminMission extends AdminForm<AloDbMission> {  

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_MISSION].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }
  
  get itemTypeName(){
    return "AdminMission"
  }

  get originalLibelle(){
    return this.original.MIS_LIBELLE
  }
}
</script>